// Navigation Menu Items
export const MENU_ITEMS = [
  {
    id: 1,
    title: 'Industrial',
    path: '/industrial',
    services: [
      {
        id: 'service-1',
        title: 'Industrial Flooring Systems',
        description: 'Epoxy Flooring & Coating • Polyurethane Flooring & Coating • Impact-Resistant Floor Layers',
        sectionId: 'paint-coatings',
        subcategories: [
          {
            id: 'sub-1',
            name: 'Epoxy Flooring & Coating',
            description: 'Epoxy flooring provides a seamless, durable surface designed to withstand heavy use in industrial, commercial, and operational environments. It forms a strong protective layer that resists scratches, stains, and chemicals, while also being easy to clean and maintain. Epoxy can be customized in appearance and finish, making it suitable for both functional and visually refined spaces.'
          },
          {
            id: 'sub-2',
            name: 'Polyurethane Flooring & Coating',
            description: 'Polyurethane flooring is known for its flexibility, abrasion resistance, and smooth finish. It handles temperature changes, foot traffic, and mechanical stress effectively, making it ideal for areas where comfort underfoot and long-lasting performance are important. Its slightly softer surface compared to epoxy helps absorb impact and reduces wear over time.'
          },
          {
            id: 'sub-3',
            name: 'Impact-Resistant Floor Layers',
            description: 'Impact-resistant flooring systems are engineered to absorb shock and prevent damage in high-activity or heavy-load environments. These layers strengthen the flooring structure, reducing cracks, chips, and surface stress caused by equipment, machinery, or frequent movement. The result is a floor that retains its integrity and appearance even under demanding conditions.'
          }
        ]
      },
      {
        id: 'service-2',
        title: 'Chemical & Environmental Protection',
        description: 'Chemical-Resistant Coatings • Acid-Resistant • Chlorinated Rubber Coatings',
        sectionId: 'texture-finishes',
        subcategories: [
          {
            id: 'sub-4',
            name: 'Chemical-Resistant Coatings',
            description: 'Chemical-resistant coatings provide a barrier against harsh substances, including acids, alkalis, solvents, and industrial chemicals. These coatings prevent corrosion, surface degradation, and contamination, making them essential for laboratories, manufacturing plants, and processing facilities where chemical exposure is frequent.'
          },
          {
            id: 'sub-5',
            name: 'Acid-Resistant Coatings',
            description: 'Acid-resistant coatings are specially formulated to withstand exposure to acidic environments without deteriorating. They protect floors, walls, and equipment from damage caused by battery acid, sulfuric acid, and other corrosive materials, ensuring operational safety and extending the service life of industrial infrastructure.'
          },
          {
            id: 'sub-6',
            name: 'Chlorinated Rubber Coatings',
            description: 'Chlorinated rubber coatings offer excellent resistance to water, chemicals, and weathering. They dry quickly, provide a durable finish, and are ideal for environments requiring fast turnaround and minimal downtime. Commonly used in chemical plants, wastewater facilities, and marine structures.'
          }
        ]
      },
      {
        id: 'service-3',
        title: 'Structural Protection & Maintenance',
        description: 'Protective Coatings • Maintenance and Restoration Solutions',
        sectionId: 'interior-exterior',
        subcategories: [
          {
            id: 'sub-7',
            name: 'Protective Coatings',
            description: 'Protective coatings shield structural surfaces from environmental damage, corrosion, and mechanical wear. Applied to steel, concrete, and other materials, these coatings extend asset life, reduce maintenance costs, and ensure compliance with safety and durability standards in industrial settings.'
          },
          {
            id: 'sub-8',
            name: 'Maintenance and Restoration Solutions',
            description: 'Maintenance and restoration solutions focus on repairing and revitalizing aging or damaged industrial surfaces. Through surface preparation, crack filling, and recoating, these services restore structural integrity, improve aesthetics, and prevent further deterioration, minimizing the need for costly replacements.'
          }
        ]
      }
    ]
  },
  {
    id: 2,
    title: 'Commercial',
    path: '/commercial',
    services: [
      {
        id: 'service-1',
        title: 'Interior Finishing & Decorative Coatings',
        description: 'Premium wall paint applications • Textured finishes and feature walls • Color consultation and design alignment',
        sectionId: 'paint-coatings',
        subcategories: [
          {
            id: 'sub-9',
            name: 'Premium Wall Paint Applications',
            description: 'Premium wall paint applications deliver smooth, even coverage with vibrant, long-lasting color that enhances the professional image of your commercial space. These finishes are selected for low odor, quick drying, and minimal disruption to daily operations. Ideal for offices, retail spaces, and hospitality environments where aesthetics and efficiency both matter.'
          },
          {
            id: 'sub-10',
            name: 'Textured Finishes and Feature Walls',
            description: 'Textured finishes and feature walls add depth, character, and visual interest to commercial interiors. From subtle patterns to bold design statements, these treatments create focal points that strengthen brand identity and customer engagement. Perfect for lobbies, showrooms, and customer-facing areas.'
          },
          {
            id: 'sub-11',
            name: 'Color Consultation and Design Alignment',
            description: 'Color consultation and design alignment services help businesses choose the right palette to reflect their brand, create the desired atmosphere, and support employee productivity. Our guidance ensures consistency across multiple locations and alignment with overall design vision.'
          }
        ]
      },
      {
        id: 'service-2',
        title: 'High-Durability Floor & Surface Treatments',
        description: 'Seamless commercial floor coatings • Protective wear-resistant surfaces • Maintenance-friendly finishes',
        sectionId: 'texture-finishes',
        subcategories: [
          {
            id: 'sub-12',
            name: 'Seamless Commercial Floor Coatings',
            description: 'Seamless commercial floor coatings provide a smooth, continuous surface that eliminates joints and seams where dirt and bacteria can accumulate. These floors are easy to clean, hygienic, and visually appealing, making them ideal for retail stores, clinics, and food service areas.'
          },
          {
            id: 'sub-13',
            name: 'Protective Wear-Resistant Surfaces',
            description: 'Protective wear-resistant surfaces are engineered to handle heavy foot traffic, equipment movement, and daily wear without showing signs of damage. These coatings maintain their appearance and performance over time, reducing the need for frequent repairs or replacements in high-traffic commercial environments.'
          },
          {
            id: 'sub-14',
            name: 'Maintenance-Friendly Finishes',
            description: 'Maintenance-friendly finishes are designed to simplify cleaning routines and reduce long-term upkeep costs. These surfaces resist stains, scuffs, and moisture, allowing facility teams to maintain a clean, professional appearance with minimal effort and downtime.'
          }
        ]
      },
      {
        id: 'service-3',
        title: 'Exterior Protection & Aesthetic Enhancement',
        description: 'Weather-resistant exterior coating systems • Façade refresh and restoration • UV and moisture-protective layers',
        sectionId: 'interior-exterior',
        subcategories: [
          {
            id: 'sub-15',
            name: 'Weather-Resistant Exterior Coating Systems',
            description: 'Weather-resistant exterior coating systems protect building facades from rain, wind, temperature changes, and UV exposure. These coatings prevent fading, cracking, and deterioration, ensuring the exterior maintains its visual appeal and structural integrity year after year.'
          },
          {
            id: 'sub-16',
            name: 'Façade Refresh and Restoration',
            description: 'Façade refresh and restoration services bring aging or weathered building exteriors back to life. Through cleaning, surface repair, and recoating, these solutions restore curb appeal, reinforce brand presence, and protect the investment in your commercial property.'
          }
        ]
      }
    ]
  },
  {
    id: 3,
    title: 'Residential',
    path: '/residential',
    services: [
      {
        id: 'service-1',
        title: 'Interior Painting & Decorative Finishes',
        description: 'Premium-grade finishes engineered for precision, durability, and timeless appeal.',
        sectionId: 'paint-coatings',
        subcategories: [
          {
            id: 'sub-17',
            name: 'Smooth and refined wall paint applications',
            description: 'Premium wall paint applications deliver smooth, even coverage with vibrant, long-lasting color that enhances the professional image of your commercial space. These finishes are selected for low odor, quick drying, and minimal disruption to daily operations. Ideal for offices, retail spaces, and hospitality environments where aesthetics and efficiency both matter.'
          },
          {
            id: 'sub-18',
            name: 'Textured and feature walls',
            description: 'Textured finishes and feature walls add depth, character, and visual interest to commercial interiors. From subtle patterns to bold design statements, these treatments create focal points that strengthen brand identity and customer engagement. Perfect for lobbies, showrooms, and customer-facing areas.'
          },
          {
            id: 'sub-19',
            name: 'Color selection and design guidance',
            description: 'Color consultation and design alignment services help businesses choose the right palette to reflect their brand, create the desired atmosphere, and support employee productivity. Our guidance ensures consistency across multiple locations and alignment with overall design vision.'
          }
        ]
      },
      {
        id: 'service-2',
        title: 'Premium Floor & Surface Treatments',
        description: 'From modern textures to classical artistry, every surface tells a story.',
        sectionId: 'texture-finishes',
        subcategories: [
          {
            id: 'sub-20',
            name: 'Seamless floor coatings for living areas',
            description: 'Premium wall paint applications deliver smooth, even coverage with vibrant, long-lasting color that enhances the professional image of your commercial space. These finishes are selected for low odor, quick drying, and minimal disruption to daily operations. Ideal for offices, retail spaces, and hospitality environments where aesthetics and efficiency both matter.'
          },
          {
            id: 'sub-21',
            name: 'Protective and easy-to-clean surface layers',
            description: 'Textured finishes and feature walls add depth, character, and visual interest to commercial interiors. From subtle patterns to bold design statements, these treatments create focal points that strengthen brand identity and customer engagement. Perfect for lobbies, showrooms, and customer-facing areas.'
          },
          {
            id: 'sub-22',
            name: 'Customized finishes for kitchens, lounges, and bedrooms',
            description: 'Color consultation and design alignment services help businesses choose the right palette to reflect their brand, create the desired atmosphere, and support employee productivity. Our guidance ensures consistency across multiple locations and alignment with overall design vision.'
          }
        ]
      },
      {
        id: 'service-3',
        title: 'Exterior Coating & Home Protection',
        description: 'Sophisticated interior, resilient exterior finishing, expert guidance to help you achieve the perfect aesthetic.',
        sectionId: 'interior-exterior',
        subcategories: [
          {
            id: 'sub-23',
            name: 'Weather-resistant exterior paint systems',
            description: 'Premium wall paint applications deliver smooth, even coverage with vibrant, long-lasting color that enhances the professional image of your commercial space. These finishes are selected for low odor, quick drying, and minimal disruption to daily operations. Ideal for offices, retail spaces, and hospitality environments where aesthetics and efficiency both matter.'
          },
          {
            id: 'sub-24',
            name: 'Moisture and UV protection coatings',
            description: 'Textured finishes and feature walls add depth, character, and visual interest to commercial interiors. From subtle patterns to bold design statements, these treatments create focal points that strengthen brand identity and customer engagement. Perfect for lobbies, showrooms, and customer-facing areas.'
          },
          {
            id: 'sub-25',
            name: 'Façade enhancement and surface restoration',
            description: 'Color consultation and design alignment services help businesses choose the right palette to reflect their brand, create the desired atmosphere, and support employee productivity. Our guidance ensures consistency across multiple locations and alignment with overall design vision.'
          }
        ]
      }
    ]
  }
];

// Home Page Services
export const HOME_SERVICES = [
  {
    id: 1,
    icon: 'home',
    title: 'Interior Painting',
    description: 'High-quality interior paint applications for refined living environments.'
  },
  {
    id: 2,
    icon: 'shield',
    title: 'Protective Coatings',
    description: 'Long-lasting protective coating solutions for various surfaces.'
  },
  {
    id: 3,
    icon: 'palette',
    title: 'Decorative Finishes',
    description: 'Custom decorative and textured finishes for unique aesthetics.'
  }
];

// Company Values
export const CORE_VALUES = [
  { id: 1, title: 'Transparency', icon: 'eye' },
  { id: 2, title: 'Innovation', icon: 'lightbulb' },
  { id: 3, title: 'Collaboration', icon: 'users' },
  { id: 4, title: 'Quality', icon: 'star' },
  { id: 5, title: 'Excellence', icon: 'award' },
  { id: 6, title: 'Respect', icon: 'heart' }
];

// Contact Information
export const CONTACT_INFO = {
  phone: '+923177073444',
  email: 'info@craftcoatsolutions.com',
  website: 'www.craftcoatsolutions.com',
  instagram: '@craftcoatsolutions',
  address: 'Lahore, Punjab, Pakistan'
};

// About Content
export const ABOUT_CONTENT = {
  mission: 'At CraftCoat Solutions, our mission is to redefine the art of surface finishing. Through precision, passion, and innovation, we deliver premium paint applications and coating solutions that combine aesthetic excellence with long-lasting protection.',
  vision: 'We envision a world where craftsmanship meets innovation, where every stroke of color enhances not just walls, but emotions. At CraftCoat Solutions, we redefine aesthetics by delivering finishes that inspire confidence, embody precision, and celebrate perfection.',
  tagline: 'Transforming Spaces with Artistry and Precision'
};

// Colors (for reference in components)
export const COLORS = {
  primary: {
    beige: '#E8DCC8',
    tan: '#C4B5A0',
    brown: '#8B7355',
  },
  dark: {
    default: '#2C2C2C',
    light: '#3D3D3D',
  },
  accent: {
    gold: '#D4AF37',
    cream: '#F5F0E8',
  }
};

// Texture/Designer Finishes Types
export const TEXTURE_FINISHES = [
  {
    id: 1,
    name: 'Two-Tone Textures',
    description: 'Balanced contrast for dynamic depth',
    icon: 'palette'
  },
  {
    id: 2,
    name: 'Stone Finish',
    description: 'Timeless charm with a tactile appeal',
    icon: 'mountain'
  },
  {
    id: 3,
    name: 'Concrete Textures',
    description: 'Industrial strength, refined aesthetic',
    icon: 'box'
  },
  {
    id: 4,
    name: 'Lime Finish',
    description: 'Breathable beauty with organic texture',
    icon: 'leaf'
  },
  {
    id: 5,
    name: 'Stencil Textures',
    description: 'Bespoke designs, endless creativity',
    icon: 'grid'
  },
  {
    id: 6,
    name: 'Marblizing',
    description: 'Luxurious sheen and subtle movement',
    icon: 'sparkles'
  },
  {
    id: 7,
    name: 'Travertine Finish',
    description: 'Classical elegance with natural warmth',
    icon: 'columns'
  },
  {
    id: 8,
    name: 'Customized Textures',
    description: 'Crafted uniquely to your vision',
    icon: 'wand'
  }
];